<template>
  <div id="account-personal-data" class="app-personal-data-wrapper ">
    <div class="content">
      <h1 class="sr-only">Meine Daten – Konto & Service</h1>
      <h2 class="text-3xl text-align-left full-width">Meine Daten</h2>
      <p v-if="isEditing" class="text-sm text-align-right">*Pflichtfeld</p>
      <div class="container-box">
        <ChangePersonalData
          v-if="isEditing"
          :current-customer.sync="currentCustomer"
          :mail-success-message="mailSuccessMessage"
          :mail-link="mailLink"
          :mail-show-forced="mailShowForced"
          :email-repeat.sync="emailRepeat"
          :loading="loading"
          @save="save"
          @discard="discard"
        >
          <template v-for="slot in possibleChildSlotsFor('Change')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ChangePersonalData>
        <div v-else class="personal-data-sheet">
          <div class="data">
            <div class="col">
              <p class="text-lg">Eingeloggt als:</p>
              <p>{{ currentCustomer.contract.msisdn }}</p>
            </div>
            <div class="col">
              <p class="text-lg">Kundennummer:</p>
              <p>{{ currentCustomer.customerId }}</p>
            </div>
            <div class="col align-start">
              <p class="text-lg">Anschrift:</p>
              <div>
                <p>{{ currentCustomer.salutation }}</p>
                <p>{{ currentCustomer.firstName }} {{ currentCustomer.lastName }}</p>
                <p>
                  {{ currentCustomer.address.street }}
                  {{ currentCustomer.address.houseNumber }}
                </p>
                <p>
                  {{ currentCustomer.address.zip }}
                  {{ currentCustomer.address.city }}
                </p>
              </div>
            </div>
            <div class="col">
              <p class="text-lg">Geburtsdatum:</p>
              <p>{{ currentCustomer.birthDate }}</p>
            </div>
            <div class="col">
              <p class="text-lg">E-Mail-Adresse:</p>
              <p>{{ currentCustomer.email }}</p>
            </div>
            <div class="col">
              <p class="text-lg">Alternative Telefonnummer:</p>
              <p>{{ currentCustomer.alternativePhone || '-' }}</p>
            </div>
            <div class="col">
              <p class="text-lg">SIM Typ:</p>
              <p v-if="currentCustomer.contract.simCard">
                {{ currentCustomer.contract.simCard.type === 'E_SIM' ? 'E-SIM' : 'Klassische SIM' }}
              </p>
            </div>

            <a class="text-sm change-password" :href="changePwUrl">
              Passwort ändern
              <img src="/files/lidl/images/new-icons/svg/chevron-right.svg" />
            </a>
          </div>

          <button @click="isEditing = true" class="change-personal-data-button text-base">
            <img src="/files/lidl/images/new-icons/svg/pen-outline.svg" />
            <span>Angaben ändern</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import transaction from '@/mixins/transaction'
import ChangePersonalData from '@/components-v2/flows/LIDL/PersonalData/ChangePersonalData.vue'
import slotProxy from '@/mixins/slotProxy'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapActions } from 'vuex'
export default {
  name: 'PersonalDataWrapperV2',
  data() {
    return {
      currentCustomer: {
        customerID: '',
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        alternativePhone: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        email: '',
        contract: {
          msisdn: '',
          simCard: {
            type: ''
          }
        }
      },
      emailRepeat: '',
      invalid: true,
      loading: false,
      isEditing: false
    }
  },
  mixins: [transaction('personalData'), slotProxy()],
  methods: {
    ...mapActions('personalData', ['changePersonalData']),
    setEmailRepeat(data) {
      this.emailRepeat = data.email
    },
    save() {
      this.loading = true
      this.changePersonalData(this.currentCustomer).then(
        () => {
          this.loading = false
          this.isEditing = false
        },
        () => {
          this.loading = false
        }
      )
    },
    discard(backup) {
      this.currentCustomer = backup
      this.isEditing = false
    }
  },
  components: {
    ChangePersonalData
  },
  props: {
    mailSuccessMessage: {
      type: Boolean,
      default: false
    },
    mailLink: {
      type: String,
      required: true
    },
    mailShowForced: {
      type: Boolean,
      default: true
    },
    changePwUrl: {
      type: String,
      default: '/account/personal-data/change-password'
    }
  },
  apollo: {
    currentCustomer: function() {
      const me = this
      return wrapQuery(
        gql`
          query personalData {
            currentCustomer {
              customerId
              salutation
              firstName
              birthDate
              lastName
              alternativePhone
              address {
                city
                houseNumber
                street
                supplement
                zip
              }
              email
              contract {
                msisdn
                simCard {
                  type
                }
              }
            }
          }
        `,
        this,
        'currentCustomer',
        {},
        function(data) {
          me.setEmailRepeat(data)
        }
      )
    }
  }
}
</script>
